import React, { Component } from 'react'
import api from '../../../../../api'
import Autosuggest from 'react-autosuggest'

const categoryLabels = {
  all: "Matches",
  subdivision: "Subdivision",
  orig_mls_number: "MLS Number",
  city: "City",
  citystate: "City",
  building: "Building",
  zip: "Zip Code",
  address: "Address",
  street_name: "Street",
  school_district: "School District",
  elementary_school: "Elementary School",
  middle_school: "Middle School",
  high_school: "High School",
  county: "County",
  state: "State",
  listing_type: "Listing Type",
  property_type: "Property Type",
  sale_type: "Sale Type"
}

const renderSuggestion = suggestion => (
  <div>
    <small>
      <strong>{categoryLabels[suggestion.field] || suggestion.field}</strong>
    </small>
    {': '}
    {suggestion.match}
  </div>
)

export default class LocationRestrictions extends Component {
  state = {
    selections: this.props.defaultValues,
    suggestions: [],
    value: ''
  }

  getValues() {
    return this.state.selections
  }

  handleSuggestionsClearRequested = () => {
    this.setState({ suggestions: [] })
  }

  handleSuggestionsFetchRequested = ({ value }) => {
    const { websiteUuid } = this.props
    return api.get('websites/location_suggestions', {
      params: {
        terms: value && value.toLowerCase(),
        website_uuid: websiteUuid,
        unrestricted: true
      }
    }).then(resp => {
      const suggestions = resp.data
        // Filter out any white space matches
        .filter(s => s.match.match(/\S/))
        // Filter out any previous selections
        .filter(s => !this.state.selections.find(sel => {
          return `${s.field}:${s.match}` === `${sel.field}:${sel.match}`
        }))
      this.setState({ suggestions })
    })
  }

  handleSuggestionSelected = (event, { suggestion }) => {
    const { selections } = this.state
    selections.push(suggestion)
    this.setState({ selections, suggestions:[], value:'' })
  }

  handleChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    })
  }

  handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault()
    }
  }

  handleClearSelectionFor = selection => event => {
    event.preventDefault()
    const { selections } = this.state
    this.setState({
      selections: selections.filter(sel => {
        return !(sel.match === selection.match && sel.field === selection.field)
      })
    })
  }

  render() {
    const { value, suggestions, selections } = this.state

    const inputProps = {
      placeholder: 'Search For A Location',
      value,
      onChange: this.handleChange,
      onKeyDown: this.handleKeyDown,
      disabled: this.props.disabled
    }

    return (
      <div>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
          getSuggestionValue={suggestion => suggestion.match}
          renderSuggestion={renderSuggestion}
          onSuggestionSelected={this.handleSuggestionSelected}
          inputProps={inputProps} />
        <ul className="locations">
          {selections.map(sel => (
            <li key={String(`${sel.field}:${sel.match}`)}>
              <strong onClick={this.handleClearSelectionFor(sel)}>×</strong>
              {' '}
              <small>
                <strong>{categoryLabels[sel.field] || sel.field}:</strong>
              </small>
              {' '}
              {sel.match}
            </li>
          ))}
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Search/LocationRestrictions.js